import * as $ from "jquery"

/**
 * Given a container and an element inside it, make sure the inner element is
 * visible by scrolling the container. Based on code from
 * http://stackoverflow.com/questions/6215779.
 */
export default function ensureElementIsVisible(parent, element) {
  const $parent = $(parent)
  const $element = $(element)

  const top = $element.position().top
  const height = $element.innerHeight()

  const visibleAreaStart = $parent.scrollTop()
  const parentHeight = $parent.innerHeight()

  if (top < 0) {
    $parent.scrollTop(visibleAreaStart + top)
  } else if (top + height > parentHeight) {
    $parent.scrollTop(visibleAreaStart + top + height - parentHeight)
  }
}
